export default "__VITE_ASSET__DIk19YMe__"